import { Colors, Lightning, Utils } from '@lightningjs/sdk'
import { focusedColor, primaryColor } from '../Lib/Common';

const defaultColor = Colors("#0D1216").get();
const focusColor = primaryColor;

export default class Button extends Lightning.Component {
  static _template() {
    return {
      h: 100,
      color: defaultColor,
      rect: true,
      Icon: {
        w: 60,
        h: 60,
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
      },
      Label: {
        x: w => w / 2,
        y: h => h / 2,
        mount: 0.5,
        text: {
          text: '',
          textColor: 0xffffffff,
        },
      },
    }
  }

  set index(v) {
    this.x = v * 70
  }

  set icon(v) {
    if (v) {
      this.tag('Icon').src = Utils.asset('images/icons/' + v + '.png')
    }
  }

  set label(v) {
    if (v) {
      this.tag('Label').text.text = v
    }
  }

  _handleEnter() {
    this.action && this.fireAncestors(this.action)
  }

  _focus() {
    this.setSmooth('color', focusColor)
  }

  _unfocus() {
    this.setSmooth('color', defaultColor)
  }
}
